<template>
	<v-app :light="themeLight" :dark="!themeLight" id="app" v-if="isAuthorized">
		<v-navigation-drawer
			app
			fixed
			v-model="drawer"
			:class="themeLight ? 'blue darken-3' : 'blue-grey darken-4'"
			class="elevation-0"
			v-if="$route.name.indexOf('Login') < 0 && $route.name != 'Logout'"
		>
			<v-toolbar flat :class="navColor" dark style="height: 64px">
				<v-list>
					<v-list-tile id="logo">
						<span>
							<fleetuse-logo />
						</span>
					</v-list-tile>
				</v-list>
			</v-toolbar>
			<v-list>
				<v-list-tile
					@click="goto('#/dashboard')"
					v-ripple
					:class="$route.name === 'Dashboard' ? 'active' : 'white--text'"
				>
					<v-list-tile-action>
						<v-icon>pie_chart</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>
							<a href="#/dashboard">Dashboard</a>
						</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
				<v-list-tile
					@click="goto('#/reservations')"
					v-ripple
					:class="
						$route.name === 'Reservations' || $route.name === 'Home'
							? 'active'
							: 'white--text'
					"
				>
					<v-list-tile-action>
						<v-icon>card_travel</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>
							<a href="#/reservations">Reserveringen</a>
						</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
				<v-list-tile
					@click="goto('#/testdrive')"
					v-ripple
					:class="$route.name === 'TestDrive' ? 'active' : 'white--text'"
				>
					<v-list-tile-action>
						<v-icon>person_pin</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>
							<a href="#/testdrive">Track & trace</a>
						</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
				<v-list-tile
					@click="goto('#/planner')"
					v-ripple
					:class="$route.name === 'Planner' ? 'active' : 'white--text'"
				>
					<v-list-tile-action>
						<v-icon>date_range</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>
							<a href="#/planner">Planner</a>
						</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
				<v-list-tile
					@click="goto('#/users')"
					v-ripple
					:class="$route.name === 'Users' ? 'active' : 'white--text'"
				>
					<v-list-tile-action>
						<v-icon>contact_mail</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>
							<a href="#/users">Klanten</a>
						</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
				<v-list-tile
					@click="goto('#/history')"
					v-ripple
					:class="$route.name === 'History' ? 'active' : 'white--text'"
				>
					<v-list-tile-action>
						<v-icon>history</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>
							<a href="#/history">Facturen</a>
						</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-list-tile
					@click="goto('#/units')"
					v-ripple
					:class="$route.name === 'Units' ? 'active' : 'white--text'"
				>
					<v-list-tile-action>
						<v-icon>directions_car</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>
							<a href="#/units">Units</a>
						</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-list-tile
					@click="goto('#/prices')"
					v-ripple
					:class="$route.name === 'Prices' ? 'active' : 'white--text'"
				>
					<v-list-tile-action>
						<v-icon>euro_symbol</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>
							<a href="#/prices">Prijsbeheer</a>
						</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
			<v-footer
				class="pa-3 blue--text text--lighten-1"
				absolute
				color="transparent"
			>
				{{ username }}
				<v-spacer></v-spacer>
				<div>
					<v-icon
						@click="themeLight = !themeLight"
						class="blue--text text--lighten-1"
						>tonality</v-icon
					>
				</div>
			</v-footer>
		</v-navigation-drawer>

		<v-toolbar
			class="elevation-0"
			:class="themeLight ? 'grey lighten-5' : 'black'"
			fixed
			app
			light
			v-if="$route.name.indexOf('Login') < 0 && $route.name != 'Logout'"
		>
			<span class="text-xs-center hidden-sm-and-up mobileHeader">{{
				pageNames[$route.name]
			}}</span>
			<v-toolbar-side-icon
				:dark="!themeLight"
				@click.stop="drawer = !drawer"
				class="grey--text text--darken-2 ml-0"
			></v-toolbar-side-icon>
			<v-spacer></v-spacer>
			<!-- <v-btn icon right @click="showUsers()">
          <v-icon>people</v-icon>
      </v-btn>-->
			<div class="navButtonRight">
				<v-btn
					icon
					right
					class="grey--text text--darken-2"
					:dark="!themeLight"
					@click="showMap()"
				>
					<v-icon>map</v-icon>
				</v-btn>
			</div>
			<v-menu offset-y left>
				<v-btn
					icon
					:dark="!themeLight"
					class="grey--text text--darken-2"
					slot="activator"
				>
					<v-icon>account_circle</v-icon>
				</v-btn>
				<v-list>
					<v-list-tile @click="goto('#/settings')">
						<v-list-tile-title>Instellingen</v-list-tile-title>
					</v-list-tile>
					<v-list-tile @click="goto('#/logout')">
						<v-list-tile-title>Uitloggen</v-list-tile-title>
					</v-list-tile>
				</v-list>
			</v-menu>
		</v-toolbar>
		<v-content>
			<router-view />
		</v-content>
		<event-tracker v-if="isLoggedIn"></event-tracker>
		<map-modal :mapDialog="mapDialog"></map-modal>
		<v-snackbar :bottom="true" :timeout="loaderTimeout" v-model="showLoading">
			<v-progress-linear
				indeterminate
				color="primary"
				height="3"
			></v-progress-linear>
		</v-snackbar>
		<v-snackbar
			:bottom="true"
			:timeout="2000"
			:color="msg_type === 'success' ? 'black' : 'orange lighten-1'"
			v-model="showMessage"
		>
			<v-icon v-if="msg_type === 'success'" color="green lighten-1"
				>check_circle</v-icon
			>
			<v-icon v-if="msg_type !== 'success'" color="red lighten-1">info</v-icon>
			{{ msg }}
			<v-btn dark flat @click.native="showMessage = false">Sluiten</v-btn>
		</v-snackbar>
		<v-snackbar
			top
			right
			:color="'gray lighten-1'"
			v-model="showPushNotification"
			multi-line
			:timeout="6000"
		>
			{{ pushMsg }}
			<v-btn dark flat @click.native="showPushNotification = false"
				>Sluiten</v-btn
			>
			<v-btn color="blue" dark flat @click.native="viewPushNotification()"
				>Bekijken</v-btn
			>
		</v-snackbar>
		<div id="unitContainer"></div>
		<v-dialog v-model="versionDialog" width="500">
			<v-card>
				<v-card-title class="headline grey lighten-2" primary-title
					>Update</v-card-title
				>
				<v-card-text>
					Er is een nieuwe versie ({{ newVersion }}) beschikbaar
					<ul v-if="updateFeatures.length">
						<li v-for="(feature, index) in updateFeatures" :key="index">
							{{ feature }}
						</li>
					</ul>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn flat @click="versionDialog = false">Annuleren</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary" flat @click="reload()">Updaten</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-app>
</template>

<script>
const serverUrl = 'https://www.auto2use.nl/manager/';
const isLocal = window.location.port.includes('80');
window.baseUrl =
	isLocal && !localStorage.getItem('live')
		? serverUrl
		: 'https://www.auto2use.nl/manager/';
window.basePath = window.baseUrl + 'index.php/';
window.dataLoading = false;

import { version } from '../package.json';
import MapModal from '@/components/MapModal';
import EventTracker from '@/components/EventTracker/EventTracker';
import FleetuseLogo from '@/components/FleetuseLogo';
import * as utils from './utils/utils';
import './utils/thunderpush.js';
import moment from 'moment';

export default {
	name: 'app',
	components: { MapModal, EventTracker, FleetuseLogo },
	data: () => ({
		themeLight: true,
		drawer: null,
		mapDialog: false,
		versionDialog: false,
		showMessage: false,
		showPushNotification: false,
		pushMsg: '',
		pushId: 0,
		msg_type: '',
		navColor: 'blue darken-3',
		loadingMsg: '',
		showLoading: false,
		loaderTimeout: 0,
		updateFeatures: [],
		newVersion: '',
		msg: '',
		items: [{ title: 'Instellingen' }, { title: 'Uitloggen' }],
		pageNames: {
			Home: 'Reserveringen',
			Reservations: 'Reserveringen',
			History: 'Historie',
			Users: 'Gebruikers',
			Units: 'Units',
			Planner: 'Planner',
			TestDrive: 'Tracker',
			Dashboard: 'Dashboard',
			settings: 'Instellingen',
			Prices: 'Prijsbeheer'
		},
		username: ''
	}),
	props: {
		sidebar: true
	},
	watch: {
		themeLight(val) {},
		$route(to, from) {
			if (from.name === 'Login') {
				this.username = localStorage.getItem('username')
					? localStorage.getItem('username')
					: '';
			}
		}
	},
	mounted() {
		var self = this;
		if (
			this.$route.name &&
			this.$route.name.indexOf('Login') < 0 &&
			this.$route.name.indexOf('Logout') < 0
		) {
			this.checkVersion();
		}

		window.emitter.$on('checkVersion', function() {
			self.checkVersion();
		});

		if (localStorage.getItem('theme')) {
			self.themeLight = localStorage.getItem('theme') === 'light';
		}

		if (!this.isAuthorized && this.$route.name !== 'Login') {
			window.location.href = '#/login';
		}

		window.emitter.$on('closeMap', function() {
			self.mapDialog = false;
		});
		window.emitter.$on('showToastMessage', function(data) {
			self.msg = data.msg;
			self.msg_type = data.type ? data.type : 'success';
			self.showMessage = true;
		});
		window.emitter.$on('showPushNotification', function(data) {
			self.pushMsg = data.msg;
			self.pushId = data.id;
			self.showPushNotification = true;
		});
		window.emitter.$on('showLoading', function(data) {
			self.loadingMsg = data.msg;

			if (!data.enable) {
				setTimeout(function() {
					self.showLoading = data.enable;
				}, 100);
			} else {
				self.showLoading = data.enable;
			}
		});
	},
	methods: {
		goto(url) {
			window.location.href = url;
		},
		showMap() {
			this.mapDialog = true;
		},
		viewPushNotification() {
			this.showPushNotification = false;
			this.$router.push('/reservations/' + this.pushId);
		},
		showUsers() {
			this.$router.push('/users/new');
		},
		checkVersion() {
			let self = this;
			let currentVersion = localStorage.getItem('version');
			if (currentVersion) {
				self.updateFeatures = '';
				utils
					.fetchData(
						(isLocal ? './src' : '.') +
							'/assets/json/versionInfo.json?ts=' +
							moment().unix(),
						'GET'
					)
					.then(function(json) {
						const newVersion = json.number;
						if (newVersion !== currentVersion) {
							self.versionDialog = true;
							self.newVersion = newVersion;
							self.updateFeatures = json.features;
						}
					});
			}
		},
		reload() {
			localStorage.setItem('version', this.newVersion);
			window.location.reload(true);
		}
	},
	computed: {
		isAuthorized() {
			return localStorage.getItem('b') || this.$route.name === 'Login';
		},
		isLoggedIn() {
			return (
				this.$route.name.indexOf('Login') < 0 && this.$route.name != 'Logout'
			);
		}
	}
};
</script>

<style lang="scss">
$blue: #1565c0;
//$bg: #eff2f5;
@import './scss/theme';
@import './scss/tables';
@import './scss/planner';
@import './scss/modals';
@import './scss/tabs';

body {
	font-size: 1rem !important;
	overscroll-behavior: contain;
	.application {
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
			'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
			'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
	}
}
.overflow-y-hidden {
	overflow: hidden;
	position: relative;
	height: 100%;
}
.navButtonRight {
	margin-right: -10px;
	width: 40px;
}
h1 {
	font-weight: normal;
}
.clickable {
	&:hover {
		cursor: pointer;
		text-decoration: underline;
	}
}
.mobileHeader {
	position: absolute;
	left: 0;
	right: 0;
	margin: 0 auto;
	width: 100%;
	color: #fff;
	font-size: 20px;
	font-weight: bold;
	pointer-events: none;
}
.v-dialog--fullscreen {
	.v-card__text {
		min-height: 65vh;
	}
}
.v-card__text {
	-webkit-overflow-scrolling: touch;
	overflow-y: auto;
	overflow-x: hidden;
	max-height: calc(90vh - 160px);
}

.v-navigation-drawer {
	max-height: initial !important;
}
.v-navigation-drawer--is-mobile {
	+ .v-toolbar .v-toolbar__content {
		background-color: $blue !important;
		i {
			color: #6aa7ef;
		}
	}
}
.v-text-field {
	max-width: 500px;
}
.application--wrap > aside {
	z-index: 99;
	.v-list {
		//margin-top: 30px;
		a {
			text-decoration: none;
			font-size: 17px;
		}
		.black--text {
			a {
				color: rgba(0, 0, 0, 0.8);
			}
		}
		.white--text {
			a {
				color: rgba(255, 255, 255, 0.9);
			}
			i {
				color: #6aa7ef;
			}
		}
		.active {
			background-color: #fafafa;
			a {
				color: #000;
			}
			i {
				color: #0065c7;
				transform: scale(1.25);
			}
		}
	}
	.v-toolbar {
		ul:after {
			position: absolute;
			content: ' ';
			width: 130px;
			height: 65px;
			background-position: 0 0;
			background-size: 72px;
			opacity: 0.9;
			top: 4px;
		}
		#logo {
			padding-left: 5px;
		}
	}
}
.dialog {
	-webkit-transform: translate3d(0, 0, 0);
	transform: translate3d(0, 0, 0);
}

.picker--date.card {
	width: 100%;
}

/* media queries */
@media only screen and (max-width: 700px) {
	.container {
		&.mpa-0 {
			padding: 0;
		}
	}

	.v-dialog:not(.v-dialog--fullscreen) {
		max-height: 90% !important;
		margin: 0;
	}

	.overlay--active:before {
		opacity: 0 !important;
		transition: none !important;
	}

	form.loading {
		input,
		.input-group__selections__comma {
			opacity: 0;
		}
	}
	.inActiveScroll {
		// max-height: 90vh;
		// overflow: hidden;
		display: none;
	}
}

.tabs__wrapper {
	overflow-x: auto;
}
.wrapper {
	width: 100%;
	max-width: 1680px;
}

.v-input__slot::before {
	border-color: rgba(193, 193, 193, 0.3) !important;
}
.layout > .v-card {
	margin-bottom: 100px;
}
.dialog:not(.dialog--fullscreen) {
	background-color: #adadad;
	-webkit-overflow-scrolling: touch;
}
.pull-down-header {
	background-color: transparent !important;
	.pull-down-content {
		color: #666;
	}
}
.overflow-y-hidden {
	.application {
		//height: 100vh;
		overflow: hidden;
	}
}

.v-card {
	&.compact {
		.layout {
			padding: 0 !important;
		}
		.input-group {
			.input-group__details {
				min-height: 14px;
			}
		}
	}
}
.progress-linear + .card {
	opacity: 0.5;
	//pointer-events: none;
}

/* animations */
.fade-enter-active {
	transition: opacity 0.5s;
}
.fade-enter {
	opacity: 0;
}

.v-picker--date.v-card {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue